import React, { Component, useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory } from 'react-router-dom';
const InvestHealthcare = () => {
  let history = useHistory();
  const checkriskprofile = (e) => {
    history.push("/risk-assestment");
  };
  const Healthcareplan = (e) => {
    history.push("/healthcareplan");
  };
  return (
    <div>
      <Header />
      <div className="section">
        <div className="container">
          <div className="login-media align-items-stretch justify-content-center ht-100p">
            <div className="sign-wrapper">
              <div className="wd-100p">
                <div className="form-group">
                  <button type="submit" onClick={checkriskprofile} className="btn btn-success button01">Invest</button>
                </div>
                <div className="form-group">
                  <button type="submit" onClick={Healthcareplan} className="btn btn-success button01">Healthcare</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default InvestHealthcare;